<template>
  <div class="consul-deal clearfix" style="position: relative">
    <div class="deal-content marginP">
      <div class="part-right consul-deal-part mypatient" v-loading="!isSuccess">
        <div
          class="evaluate-wrap consul-sheet-wrap deal-sheet-wrap"
          v-if="isSuccess"
        >
          <div>
            <!--<ImageAmplify/>-->
            <!--<div class="video-Top">-->
            <!--<label class="searchTip" style="color:#92412B;">状态 :{{consultDetailObj.consultStatusDescription}}</label>-->
            <!--</div>-->
            <div class="clearfix" style="background: #fff">
              <div class="launch-title1" style="background: #f9f9f9">
                <p>基本信息</p>
              </div>
              <div
                style="box-sizing: border-box; padding: 10px 20px 0"
                class="box-borders"
              >
                <div class="clearfix" style="height: 36px">
                  <span
                    class="name patient-list-item jet-black lineH30 fontSize14"
                    >{{ consultDetailObj.compatName || ddxx.patname }}</span
                  >
                  <span class="patient-list-item lineH30 jet-gray">{{
                    ddxx.zjhm | getSexFromIdCard
                  }}</span>
                  <span class="patient-list-item lineH30 jet-gray">{{
                    ddxx.zjhm | getAgeFromIdCard
                  }}</span>
                  <span class="patient-list-item lineH30 jet-gray"
                    >患者病历号：{{ ddxx.jzkh }}</span
                  >
                </div>
                <div class="clearfix" style="height: 36px">
                  <span class="patient-list-item lineH30 jet-gray"
                    >电话号码：{{
                      consultDetailObj.compatMobile || ddxx.sjh
                    }}</span
                  >
                  <span class="patient-list-item lineH30 jet-gray"
                    >身份证：{{ ddxx.zjhm }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="launch-title1"
            style="margin-top: 10px; background: #f9f9f9"
          >
            <p>就诊记录信息</p>
          </div>
          <div
            style="box-sizing: border-box; padding: 10px 20px; background: #fff"
            class="box-borders"
          >
            <el-table :data="list" border>
              <el-table-column
                prop="patname"
                label="患者姓名"
              ></el-table-column>
              <el-table-column
                prop="deptname"
                label="挂号科室"
              ></el-table-column>
              <el-table-column
                prop="docname"
                label="挂号医生"
              ></el-table-column>
              <el-table-column
                prop="numdate"
                label="号源日期"
              ></el-table-column>
              <el-table-column
                prop="numtime"
                label="号源时间"
              ></el-table-column>
              <el-table-column prop="regfee" label="挂号费"></el-table-column>
              <el-table-column label="详情" width="300">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    @click.prevent="getDetails(scope.row)"
                    >处方
                  </el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click.prevent="medical(scope.row)"
                    >病历
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row
              class="pagination-wrapper"
              type="flex"
              justify="end"
              style="margin-top: 30px"
            >
              <el-pagination
                layout="total,sizes,prev, pager, next"
                @size-change="handleSizeChange"
                :current-page.sync="page.pageNum"
                @current-change="onCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :total="page.total"
              ></el-pagination>
            </el-row>
          </div>
        </div>
      </div>
      <!--遮罩层-->
      <div class="ssts" v-show="showBox"></div>
    </div>
    <router-view></router-view>
  </div>
</template>
<style>
</style>
<script>
import ImageAmplify from "../common/ImageAmplify.vue";
import fileClassification from "../../utils/FileClassificationUtils.js";
import { API_URL } from "../../data/Url";
import { imageAmplify } from "../../utils/ImageAmplify.js";
import { formatUnixTime } from "../../utils/DateFormat.js";
import { getAgeFromIdCard, getSexFromIdCard } from "../../utils/filters";

export default {
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
      },
      isSuccess: false,
      consultDetailObj: {},
      showBox: false,
      imgList: [], //附件图片列表
      fileList: [], //附件文件列表
      /*上传图片*/
      adviceImgList: [], // 咨询意见图片
      adviceFileList: [], // 咨询意见附件
      uploadFileCount: 0, //上传的文件数量，最大为9个
      uploadData: {}, //up-load组件的data数据
      imgUploadList: [], //需上传的图片列表
      fileUploadList: [], //需上传的文件列表
      attaIdList: [], //需要提交的附件列表
      uploadUrl: API_URL, //上传图片action地址
      tpwjdzs: [],
      fjwjdzs: [],
      list: [],
    };
  },
  computed: {
    ddxx() {
      const { consultDetailObj } = this;
      if (consultDetailObj.ddxx && consultDetailObj.ddxx.code === "0") {
        return consultDetailObj.ddxx.obj;
      }
      return {};
    },
    upLoadList: function () {
      //获取上传图片和文件的id
      let imgUploadListArr = [];
      let fileUploadListArr = [];
      for (let i = 0; i < this.imgUploadList.length; i++) {
        imgUploadListArr.push(this.imgUploadList[i].response.obj);
      }
      for (let i = 0; i < this.fileUploadList.length; i++) {
        fileUploadListArr.push(this.fileUploadList[i].response.obj);
      }
      return this.adviceImgList.concat(imgUploadListArr, fileUploadListArr);
    },
  },
  created: function () {
    //创建时获取会诊单数据
    this.getConsultDetail();
  },
  watch: {},
  filters: { getAgeFromIdCard, getSexFromIdCard },
  components: {
    ImageAmplify,
  },
  mounted: function () {
    this.init();
  },
  methods: {
    medical(item) {
      if(item.visitid==''){
        this.$message.error("没有就诊不可查看病历");
        return
      }
      this.$router.push({
        path: "/main/medicalList",
        query: { id: item.visitid },
      });
    },
    getDetails(item) {
      this.$store.state.prescription = item;
      this.$router.push({ path: "/main/prescriptionDetails" });
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.init();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.init();
    },
    async init() {
      let that = this;
      let options = {
        hosid: that.hosId,
        patientid: JSON.parse(localStorage.getItem("hosobj")).hosPatid,
        pageNum: that.page.pageNum,
        pageSize: that.page.pageSize,
        token: localStorage.getItem("token"),
      };
      let data = await this.$http(
        "smarthos.yygh.patient.visit.record.list",
        options
      );

      if (data.code == 0) {
        that.list = data.list;
        that.page.total = data.rowCount;
      }
    },
    formatUnix: function (time) {
      //将unix时间戳转换未yyyy-MM-dd HH:mm
      return formatUnixTime(time);
    },
    async getConsultDetail() {
      //根据consultId获取会诊单数据
      let options = {
        id: JSON.parse(localStorage.getItem("hosobj")).ddid,
        // id:"10000907",
        token: localStorage.getItem("token"),
      };
      let data = await this.$http(
        "smarthos.online.outpatient.pack.info",
        options
      );

      if (data.code == 0) {
        this.isSuccess = true;
        this.consultDetailObj = data.obj;
      }
      this.fileList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
      this.imgList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
      this.adviceImgList = [];
      this.adviceFileList = [];
      fileClassification(data.obj.attaList, this.imgList, this.fileList);
      fileClassification(
        data.obj.adviceAttaList,
        this.adviceImgList,
        this.adviceFileList
      ); // 获取咨询意见附件
      this.tpwjdzs = this.imgList;
      this.fjwjdzs = this.fileList;
      this.uploadFileCount = this.adviceImgList.length;
    },
    handleImageAmplify: function (index = 1, imgList = [], ev) {
      //图片放大
      let e = ev || event;
      let element = e.target || e.srcElement;
      let src = element.src;
      let obj = {
        imgList: imgList,
        index: index,
      };
      this.$store.dispatch("getAmplifyImageArr", obj); // 储存需要放大的数组，用于左右按钮切换
      imageAmplify(src);
    },
    // beforeUpload: function (file) {//上传图片/文件前钩子函数
    //     let _this = this;
    //     if (_this.uploadFileCount < upLoadFileCountMax) {//如果上传数量小于9
    //         _this.uploadFileCount++;
    //         return new Promise(function (resove, reject) {
    //             _this.uploadData = Object.assign({
    //                 'file': file,
    //                 'module':'CONSULT_GROUP',
    //                 'fileType':"IMAGE",
    //                 'Service': "smarthos.system.file.upload"
    //             }, upLoadBasicParam);
    //             resove(true);
    //         });
    //     } else {
    //         _this.uploadFileCount++;// 如果返回false，则会调用移除图片函数 ，uploadFileCount会减1
    //         Message({
    //             showClose: true,
    //             message: "上传图片数量不能多于9张",
    //             type: "info"
    //         });
    //         return false;
    //     }
    // },
    // beforeUploadFile: function(file){//上传文件前钩子函数
    //     let _this = this;
    //     let maxsize=1024*600;
    //     let type= file.name.replace(/.+\./,"")
    //     if(type=="RAR"||type=="pdf"||type=="xls"||type=="xlsx"||type=="doc"||type=="docx"||type=="txt"||type=="rar"||type=="zip"||type=="PDF"){
    //     }else{
    //         Message({
    //             showClose: true,
    //             message:"不支持该类型文件上传",
    //             type: "error"
    //         })
    //         return false;
    //     }
    //     if(file.size/1024>maxsize){
    //         Message({
    //             showClose: true,
    //             message:"附件大小不能大于500mb",
    //             type: "error"
    //         })
    //         return false;
    //     }else{
    //         return new Promise(function (resove, reject) {
    //             _this.uploadData = Object.assign({
    //                 'file': file,
    //                 'module':'CONSULT_GROUP',
    //                 'fileType':"OTHER",
    //                 'Service': "smarthos.system.file.upload"
    //             }, upLoadBasicParam);
    //             resove(true);
    //         });
    //     }
    //     /*1.2.3版本return false 还是会增加item项，所以增加如下一句代码， 下个elementui版本会修复，升级版本需要删除此行代码。 需在upload上加ref='uploadRef'*/
    //     //_this.$refs.uploadRef.uploadFiles.pop();
    // },
    // onSuccessImg: function (response, file, fileList) {//上传图片成功后钩子
    //     if (response.succ) {
    //         this.imgUploadList = fileList;
    //     } else {
    //         Message({
    //             showClose: true,
    //             message: response.msg,
    //             type: "error"
    //         });
    //     }
    // },
    // onSuccessFile: function(response, file, fileList){//上传文件成功后钩子
    //     if(response.succ){
    //         this.fileUploadList = fileList;
    //     }else {
    //         Message({
    //             showClose: true,
    //             message: response.msg,
    //             type: "error"
    //         });
    //     }
    // },
    // onRemoveFile: function (file, fileList) {//删除上传文件
    //     this.fileUploadList = fileList;
    // },
    // onRemoveImg: function (file, fileList) {//删除上传图片
    //     if (this.uploadFileCount > 0) {//数量减1
    //         this.uploadFileCount--;
    //     }
    //     this.imgUploadList = fileList;
    // },
    // handlePreview: function (file) {//上传的图片放大
    //     let obj = {
    //         imgList: [],
    //         index: 0
    //     };
    //     this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
    //     imageAmplify(file.url);
    // },
  },
};
</script>
